export default __webpack_public_path__ + "static/media/ICON_StoreReviews.b062d252.svg";